var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCirclePlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#00BAC6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.402 14.98v2.04h-3.38v3.38h-2.04v-3.38h-3.38v-2.04h3.38V11.6h2.04v3.38h3.38Z",
  fill: "#fff"
})));
export { SvgCirclePlus as ReactComponent };
export default __webpack_public_path__ + "aa060e2e228777bd62f17c79409ee403.svg";